
/*
    General use functions
*/

//
// extract the 24-time from a date object
//
export function getTimeStringFromDate(d){
    if(!d){
        return "";
    }

    let valToUse = d;

    if(typeof d === "string"){
        valToUse = new Date(d);
        console.log("CONVERT TO DATE", d, valToUse);
    }

    let hour = valToUse.getHours();
    let minute = valToUse.getMinutes();

    hour = hour < 10 ? "0"+hour: hour+"";
    minute = minute < 10 ? "0"+minute: minute+"";

    return `${hour}:${minute}`;
}

//
// scroll the page to the position of the element passed in
// (for a react ref, this would actually be ref.current)
//
export function scrollToRef(ref) {

    setTimeout(() => {
        console.log("ARE WE SCROLLING?", ref);

        const [scrollParent, scrollContainer] = getScrollParent(ref);
    
        if(scrollParent && scrollContainer){
    
            console.log("SCROLLING FOUND PARENT", scrollParent, scrollContainer);
    
            const parentTop = scrollParent.getBoundingClientRect().top;
            const containerTop = scrollContainer.getBoundingClientRect().top;
            const scrollPos = scrollContainer.scrollTop;
    
            let scrollDistance = parentTop-containerTop;
            
            const parentHeight = scrollParent.getBoundingClientRect().height;
            const containerHeight = scrollContainer.getBoundingClientRect().height;

            console.log("SCROLLING TOPS", parentTop, containerTop, scrollPos, scrollDistance, parentHeight, containerHeight);

            console.log("SCROLLING STATE", parentTop + parentHeight - containerTop - containerHeight, parentHeight);

            scrollDistance = parentTop + parentHeight - containerTop - containerHeight;

            if(scrollDistance > 0){
                scrollDistance += 30;
            }
            else if(parentTop < containerTop) {
                scrollDistance = parentTop - containerTop - 30;
            }
            else{
                // there's some limiting negative case here... what is it?
                // I want to ignore this except in the case that what?

                return;
            }

            // const scrollOptions = {
            //     top: scrollPos + scrollDistance,
            //     left: 0,
            //     behavior: "smooth"
            // };

            // scrollContainer.scrollTo(scrollOptions);

            runScrollSteps(scrollContainer, scrollPos, scrollDistance);
        } 
    }, 100);
}

//
// used by scrollToRef, goes up the parent chain until we reach
// an element which is scrollable (scrollheight > clientheight)
//
function getScrollParent(node) {
    if (node == null) {
        return [null, null];
    }

    const parent = node.parentNode;

    if (parent && parent.scrollHeight > parent.clientHeight) {
        return [node, parent];
    } else {
        return getScrollParent(parent);
    }
}

//
// scroll in pieces, since the smooth behavior isn't working
//
function runScrollSteps(container, current, distance) {
    let step = distance / 8;
    let count = 0;

    const f = () => {
        if(count < 8) {
            count++;
            container.scrollTo(0, current + step*count);
            window.requestAnimationFrame(f);
        }
    };

    f();
}

//
// return a new list, which is the input list with the input element added
//
export const addElement = (list, element) => {
    return [...list, element];
}

//
// return a new list with the given element replaced
//
export const replaceElement = (list, element, index) => {
    return list.map((obj, i) => {
        if(i === index){
            return element;
        }
        else{
            return obj;
        }
    });
}

//
// return a new list which is the input list without the object at the given index
//
export const deleteElement = (list, index) => {
    const newList = [];

    list.forEach((obj, i) => {
        if(i !== index){
            newList.push(obj);
        }
    });

    return newList;
}

//
// add the input minutes to the current time and return
//
export function getCurrentDateWithMinutesAdded(min){
    const d = new Date();
    d.setTime(d.getTime() + min*60*1000);
    return d;
}

//
//
//
//

const MONTHS = [
    "JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"
];

//
// put it all into this format
// 26-NOV-20 01:11 AM
// day-MON-year hour:min XM
//
export function formatDateTime(initialDateTime, time = null, noDateToday = false){
    const init = new Date(initialDateTime);

    const initHours = init.getHours();
    const initMins = init.getMinutes();

    let newHours, newMins;
    let d = null;

    if(time){
        [newHours, newMins] = time.split(":").map(v => parseInt(v));
    
        // only assume it's the next day if we're at least 22 hours different
        if(newHours < initHours && initHours - newHours > 21){
            // next day
            d = new Date(init.getTime() + 86400000);
            // d.setDate(init.getDate() + 1);
            console.log("next day", d);
        }
        else{
            // same day
            d = init;
        }
    }
    else{
        d = new Date(initialDateTime);
        newHours = initHours;
        newMins = initMins;
    }

    // put it together

    const day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
    const month = MONTHS[d.getMonth()];
    const year = d.getFullYear() % 100;

    let datePortion = "";

    if(noDateToday && isDateToday(d)) {
        // do nothing
    }
    else {
        datePortion = `${day}-${month}-${year} `;
    }

    let hour = newHours > 12 ? newHours - 12 : newHours;
    if(hour === 0){
        // handle the midnight case
        hour = "12";
    }
    else if(hour < 10){
        hour = "0" + hour;
    }
    const min = newMins < 10 ? "0" + newMins : newMins;
    const xm = newHours >= 12 ? "PM" : "AM";

    return `${datePortion}${hour}:${min} ${xm}`;
}

function isDateToday(dt) {
    const today = new Date();
    return dt.day === today.day 
            && dt.month === today.month
            && dt.year === today.year;
}

// 45 minutes in milliseconds
const DEPART_CHECK_LIMIT = 45*60*1000;

//
// check whether the depart time for the given trip is within the above limit
// and if not then prompt the user
//
export function checkDepartTimeWithinLimit(trip){
    // in both cases, the parameter is referring to this.props.data
    // so pick the value out and go from there

    const departureTime = new Date(trip.SchedDepTime);

    const now = new Date();

    const aheadDiff = departureTime - now;
    const behindDiff = now - departureTime;

    if(
        aheadDiff >= DEPART_CHECK_LIMIT
    ) {
        // prompt here
        // eslint-disable-next-line no-restricted-globals
        return confirm(`It's ${Math.floor(aheadDiff/60000)} minutes before the scheduled departure time, are you sure you want to do this?`);
    }

    if(behindDiff >= DEPART_CHECK_LIMIT ){
        // prompt here
        // eslint-disable-next-line no-restricted-globals
        return confirm(`It's ${Math.floor(behindDiff/60000)} minutes after the scheduled departure time, are you sure you want to do this?`);
    }

    return true;
}


///////////////////////////////////////////////////////////////////////

// NOT CURRENTLY IN USE

//
//
//

//
// from: https://stackoverflow.com/questions/4770025/how-to-disable-scrolling-temporarily
//

// left: 37, up: 38, right: 39, down: 40,
// spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
const keys = {37: 1, 38: 1, 39: 1, 40: 1};

function preventDefault(e) {
    e.preventDefault();
}

function preventDefaultForScrollKeys(e) {
    if (keys[e.keyCode]) {
        preventDefault(e);
        return false;
    }
}

// modern Chrome requires { passive: false } when adding event
var supportsPassive = false;
try {
    window.addEventListener("test", null, Object.defineProperty({}, 'passive', {
        get: function () { supportsPassive = true; } 
    }));
} catch(e) {}

var wheelOpt = supportsPassive ? { passive: false } : false;
var wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';

// call this to Disable
export const disableScroll = () => {
    window.addEventListener('DOMMouseScroll', preventDefault, false); // older FF
    window.addEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
    window.addEventListener('touchmove', preventDefault, wheelOpt); // mobile
    window.addEventListener('keydown', preventDefaultForScrollKeys, false);
}

// call this to Enable
export const enableScroll = () => {
    window.removeEventListener('DOMMouseScroll', preventDefault, false);
    window.removeEventListener(wheelEvent, preventDefault, wheelOpt); 
    window.removeEventListener('touchmove', preventDefault, wheelOpt);
    window.removeEventListener('keydown', preventDefaultForScrollKeys, false);
}

//
//
//